import { type ElementType, type ReactNode } from 'react'

import { typography, type TypographyVariant } from './variants'

type HeadingVariant =
  | 'display'
  | 'h1'
  | 'h2'
  | 'h2Accent'
  | 'h2Mission'
  | 'h3'
  | 'h3Small'
  | 'stat'
  | 'statLabel'

export interface HeadingProps {
  as?: ElementType
  variant?: HeadingVariant
  children: ReactNode
  className?: string
  /** Optional color override – e.g. text-white, text-[#111] */
  color?: string
}

const variantToDefaultTag: Record<HeadingVariant, ElementType> = {
  display: 'h1',
  h1: 'h1',
  h2: 'h2',
  h2Accent: 'h2',
  h2Mission: 'h2',
  h3: 'h3',
  h3Small: 'h2',
  stat: 'p',
  statLabel: 'p',
}

export function Heading({ as, variant = 'h2', children, className = '', color }: HeadingProps) {
  const Tag = as ?? variantToDefaultTag[variant]
  const baseClasses = typography[variant as TypographyVariant]
  const classes = [baseClasses, color, className].filter(Boolean).join(' ')
  return <Tag className={classes}>{children}</Tag>
}
